import { Component, OnInit,Input } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-owl-carousel',
  templateUrl: './owl-carousel.component.html',
  styleUrls: ['./owl-carousel.component.sass']
})
export class OwlCarouselComponent implements OnInit {

  @Input('customOptions') customOptions: object;
  @Input('response') response: object;
  @Input('options') options: object;
  @Input('alt') alt: string;
  owlOptions : OwlOptions = {};

  constructor() { }

  ngOnInit(): void {
    this.owlOptions =this.customOptions;
    
  }
  returnZero() {
    return 0
  }

}
